<template>
  <div class="main-page" ref="mainPage">
  <div class="first-page">
      <div class="font-area" :class="globalTransition">
        <div class="p1">
          <p>{{$t('mainPage.p1.h')}}</p>
         </div>
        <div class="p2">
          <p>{{$t('mainPage.p1.p1')}}</p>
          <p>{{$t('mainPage.p1.p2')}}</p>
          <p>{{$t('mainPage.p1.p3')}}</p>
         </div>
        <div class="p3">
          <p>{{$t('mainPage.p2.p1')}}</p>
          <p>{{$t('mainPage.p2.p2')}}</p>
        </div>
    <transition name="fade">
  <div
    v-if="!showDiscoveryPage"
    class="p4" @mouseenter="rightArrowShow=true" @mouseleave="rightArrowShow=false"
    @click="showDiscoveryBtnClick">
    <transition name="fade">
      <div class="icon-div" :class="rightArrowShow?'show':''">
        <i class="el-icon-arrow-right"></i></div>
    </transition>
    <p>{{$t('mainPage.p3.p1')}} <span style="font-weight: 800">DIMER</span></p>
  </div>
</transition>
      </div>
    <transition name="fade">
      <div v-if="showDiscoveryPage&&!hideDownBtn"
           class="p5" @mouseenter="rightArrowShow=true"
           @mouseleave="rightArrowShow=false"
           @click="jump2nextPage('discoveryPage')"
      >
      <transition name="fade">
        <div class="icon-div" :class="rightArrowShow?'show':''">
          <i class="el-icon-arrow-down"></i></div>
      </transition>
    </div></transition>
  </div>
    <discoveryPage v-if="showDiscoveryPage"
                   ref="discoveryPage" class="discovery-page"></discoveryPage>
  </div>
</template>

<script>
import discoveryPage from '@/views/discoveryPage';

export default {
  name: 'index',
  components: {
    discoveryPage,
  },
  data() {
    return {
      rightArrowShow: false,
      doTransition: true,
      showDiscoveryPage: false,
      hideDownBtn: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
  },
  watch: {
    globalTransition() {
      this.doTransition = !this.doTransition;
    },
  },
  methods: {
    showDiscoveryBtnClick() {
      this.showDiscoveryPage = true;
      this.rightArrowShow = false;
    },
    handleScroll() {
      // eslint-disable-next-line
      if (this.$refs.mainPage === undefined) {
        return;
      }
      this.hideDownBtn = this.$refs.mainPage.scrollTop >= 40;
    },
    jump2nextPage(ref) {
      const that = this;
      let distance = this.$refs.mainPage.scrollTop;
      const total = this.$refs[ref].$el.offsetTop - 100;
      let step = total / 50;
      if (total > distance) {
        // eslint-disable-next-line
        scrollDown();
      } else {
        const newTotal = distance - total;
        step = newTotal / 50;
        // eslint-disable-next-line
        scrollUp();
      }


      function scrollDown() {
        if (distance < total) {
          distance += step;
          that.$refs.mainPage.scrollTop = distance;
          window.pageYOffset = total;
          setTimeout(scrollDown, 8);
        } else {
          that.$refs.mainPage.scrollTop = total;
          window.pageYOffset = total;
        }
      }
      function scrollUp() {
        if (distance > total) {
          distance -= step;
          that.$refs.mainPage.scrollTop = distance;
          window.pageYOffset = total;
          setTimeout(scrollUp, 10);
        } else {
          that.$refs.mainPage.scrollTop = total;
          window.pageYOffset = total;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-page {
  background-image: url("../../assets/bg.jpg");
}
  .first-page{
    padding-top: 10rem;
    .font-area{
      .p2{
        white-space: nowrap;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mainPage/index.vue